import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLang: string = 'es'; // Idioma por defecto

  constructor(
    private translate: TranslateService,
  ) {
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang(this.currentLang);

  }

  setLanguage(lang: string, forceReload: boolean = false): void {
    console.log(`Idioma solicitado: ${lang}`);
    
    if (lang !== this.currentLang) {
      this.currentLang = lang;
      this.translate.use(lang);
    }
  }
   

  getLanguage(): string {
    return this.currentLang;
  }


  translateInstant(key: string): string {
    return this.translate.instant(key);
  }

  
}